import script from "./RfidAssociationLogsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RfidAssociationLogsPage.vue?vue&type=script&setup=true&lang=js"

import "./RfidAssociationLogsPage.vue?vue&type=style&index=0&id=1fd63b93&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fd63b93"]])

export default __exports__